import React from "react";
import { useListRegions } from "@workspace/api-client-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export function RegionsList() {
  const { data: regions, isLoading, error } = useListRegions();

  if (isLoading) return <div className="p-6 animate-pulse"><div className="h-8 bg-gray-200 w-1/4 rounded mb-6"></div><div className="h-64 bg-gray-200 rounded"></div></div>;
  if (error || !regions) return <div className="p-6 text-red-500">Failed to load regions.</div>;

  return (
    <Card className="border-0 shadow-sm">
      <CardHeader>
        <CardTitle className="text-lg text-[#0B132B]">Regions</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader className="bg-gray-50">
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Code</TableHead>
              <TableHead className="text-right">Agent Count</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {regions.map((region) => (
              <TableRow key={region.id}>
                <TableCell className="font-medium text-[#0B132B]">{region.name}</TableCell>
                <TableCell>{region.code}</TableCell>
                <TableCell className="text-right">{region.agentCount || 0}</TableCell>
              </TableRow>
            ))}
            {regions.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} className="text-center p-8 text-gray-500">No regions found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
